import apiFAC from "../apiFAC"

export const getListShippingCarrier = async(payload) => {
    return apiFAC.makeAuthRequest({
        url: `/packing/shipping-carriers/search`,
        method: 'POST',
        data: payload,
    })
}